import { createSlice } from "@reduxjs/toolkit";

const monthlySummary = createSlice({
    name: "monthlySummary",
    initialState: {
        monthlySummaryData: {}
    },
    reducers: {
        setMonthlySummaryData: (state, { payload }) => {
            state.monthlySummaryData = payload;
        }
    }
});

export const { setMonthlySummaryData } = monthlySummary.actions;

export default monthlySummary.reducer;